import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Hook to track page views in Appcues on route changes.
 * Should be used inside components wrapped by RouterProvider.
 */
export function useAppcuesPageTracking() {
  const location = useLocation()

  useEffect(() => {
    if (window.Appcues) {
      window.Appcues.page()
    }
  }, [location.pathname])
}
